import { useMutation, useQueryClient } from '@tanstack/vue-query';

import { unsubscribeUserToKeywords } from '@/api/keywords';
import { handleUserKeywordsSuccessChange } from '@/composables/keywords/keywordsHelper';

export function useUnsubscribeUserToKeywords({ onSuccess } = {}) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ keywords }) => {
      return unsubscribeUserToKeywords({ keywords });
    },
    onSuccess: (data) => {
      handleUserKeywordsSuccessChange({ queryClient });

      onSuccess?.(data);
    },
  });

  return {
    unsubscribeUserToKeywords: mutation.mutate,
    ...mutation,
  };
}
